const pendingRequests = new Map<string, Promise<unknown>>();

export const dedupeInFlight = <T>(key: string, request: () => Promise<T>): Promise<T> => {
  const pending = pendingRequests.get(key);
  if (pending) return pending as Promise<T>;

  const requestPromise = request();
  pendingRequests.set(key, requestPromise);

  const clear = () => {
    if (pendingRequests.get(key) === requestPromise) pendingRequests.delete(key);
  };
  requestPromise.then(clear, clear);

  return requestPromise;
};
